// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { ehrBaseUrl } from '@/settings'

export const getPatientDetailsByMRN = async (query) => {
  try {
    const fetchParams = {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(query),
    }
    const url = `${ehrBaseUrl}/patient_search_by_mrns`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result || !result.results || result.results.length === 0) { return [] }
    // Translate the response to the format expected by the frontend.
    return result.results
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
